<div class="full-width full-height bms-theme p-24">
  <ng-container #contentSwitcherContainer />
</div>
